import React from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import Button from '@/shared/Buttons/Button';
import Checkbox from '@/shared/Checkboxs/Checkbox';
import ControlledInput from '@/shared/Input/ControlledInput';
import InputRange from '@/shared/Inputs/InputRage/InputRange';
import Modal from '@/shared/Modal/Modal';
import RadioGroup from '@/shared/RadioGroup/RadioGroup';
import ToggleSwitcher from '@/shared/ToggleSwitcher/ToggleSwitcher';
import type {
  AllowFiltersInAppT,
  MoreFiltersT,
} from '@/widgets/MainBlock/MainSearch/types';
import styles from './styles.module.css';

type OtherMainFilterModal = {
  moreFilter: MoreFiltersT;
  allowFilters: AllowFiltersInAppT;
};

const OtherMainFilterModal: React.FC<OtherMainFilterModal> = ({
  moreFilter,
  // allowFilters,
}) => {
  const { filters, setFilters, delModal } = useApp();

  const applyFilters = (showOnMap: boolean = false) => {
    // Additional logic for showing on map if needed

    // Close the modal
    delModal();
  };

  return (
    <Modal title="Фильтры">
      <div className={styles.filterContainer}>
        <div className={styles.formBlock}>
          {moreFilter.map((block) => (
            <React.Fragment key={block.id}>
              {block.properties.map(
                (data) =>
                  !(
                    ['cena', 'price'].includes(data.slug) ||
                    data.title === 'Цена'
                  ) && (
                    <div
                      className={
                        data.property_type === 'boolean'
                          ? styles.formItemBoolean
                          : styles.formItem
                      }
                      key={data.id}
                    >
                      <span className={styles.formLabel}>{data.title}</span>
                      {data.filter_type === 'common' ? (
                        <div>
                          {/* Checkbox */}
                          {data.component === 'Checkbox' && data.data && (
                            <div className={styles.checkboxGroup}>
                              {data.data.map(
                                (option: string, optionIndex: number) => (
                                  <label
                                    key={optionIndex}
                                    className={styles.checkboxLabel}
                                  >
                                    <Checkbox
                                      isChecked={
                                        filters[`filters[${data.slug}][]`]?.[
                                          optionIndex
                                        ] === option
                                      }
                                      onChange={() => {
                                        const newValues = { ...filters };
                                        if (
                                          !newValues[`filters[${data.slug}][]`]
                                        )
                                          newValues[`filters[${data.slug}][]`] =
                                            '';
                                        //@ts-expect-error
                                        newValues[`filters[${data.slug}][]`][
                                          optionIndex
                                        ] = option;
                                        setFilters(
                                          `filters[${data.slug}][]`,
                                          newValues[`filters[${data.slug}][]`],
                                        );
                                      }}
                                    />
                                    <span>{option}</span>
                                  </label>
                                ),
                              )}
                            </div>
                          )}

                          {/* Radio Button */}
                          {data.component === 'RadioButton' && data.data && (
                            <RadioGroup
                              name={data.slug}
                              options={data.data}
                              //@ts-expect-error
                              value={filters[`filters[${data.slug}][]`]}
                              onChange={(value) =>
                                setFilters(`filters[${data.slug}][]`, value)
                              }
                            />
                          )}

                          {/* Radio Button Pills */}
                          {data.component === 'RadioButtonPills' &&
                            data.data && (
                              <RadioGroup
                                name={data.slug}
                                options={data.data}
                                type="pills"
                                //@ts-expect-error
                                value={filters[`filters[${data.slug}][]`]}
                                onChange={(value) =>
                                  setFilters(`filters[${data.slug}][]`, value)
                                }
                              />
                            )}

                          {data.property_type === 'string' && (
                            <ControlledInput
                              type="text"
                              className={styles.textInput}
                              placeholder={data.title}
                              //@ts-expect-error
                              value={filters[`filters[${data.slug}]`] || ''}
                              onChange={(value) =>
                                setFilters(`filters[${data.slug}]`, value)
                              }
                            />
                          )}

                          {data.property_type === 'int' && (
                            <InputRange
                              filterName={data.title}
                              onChangeFrom={setFilters}
                              onChangeTo={setFilters}
                              fromPlaceholder="От"
                              toPlaceholder="До"
                              fromKey={`filters[${data.slug}][from]`}
                              toKey={`filters[${data.slug}][to]`}
                            />
                          )}

                          {data.property_type === 'boolean' &&
                            data.component !== 'RadioButton' &&
                            data.component !== 'RadioButtonPills' && (
                              <ToggleSwitcher
                                name={`filters[${data.slug}]`}
                                //@ts-expect-error
                                value={filters[`filters[${data.slug}]`] || '0'}
                                onChange={(value) =>
                                  //@ts-expect-error
                                  setFilters(`filters[${data.slug}]`, value)
                                }
                              />
                            )}
                        </div>
                      ) : (
                        <div>
                          {/* Checkbox */}
                          {data.component === 'Checkbox' && data.data && (
                            <div className={styles.checkboxGroup}>
                              {data.data.map(
                                (option: string, optionIndex: number) => (
                                  <label
                                    key={optionIndex}
                                    className={styles.checkboxLabel}
                                  >
                                    <Checkbox
                                      isChecked={
                                        filters[`filters[${data.slug}][]`]?.[
                                          optionIndex
                                        ] === option
                                      }
                                      onChange={() => {
                                        const newValues = { ...filters };
                                        if (
                                          !newValues[`filters[${data.slug}][]`]
                                        )
                                          //@ts-expect-error
                                          newValues[`filters[${data.slug}][]`] =
                                            {};
                                        //@ts-expect-error
                                        newValues[`filters[${data.slug}][]`][
                                          optionIndex
                                        ] = option;
                                        setFilters(
                                          `filters[${data.slug}][]`,
                                          newValues[`filters[${data.slug}][]`],
                                        );
                                      }}
                                    />
                                    <span>{option}</span>
                                  </label>
                                ),
                              )}
                            </div>
                          )}

                          {/* Radio Button */}
                          {data.component === 'RadioButton' && data.data && (
                            <RadioGroup
                              name={data.slug}
                              options={data.data}
                              value={
                                filters[`filters[${data.slug}][]`] as string
                              }
                              onChange={(value) =>
                                setFilters(`filters[${data.slug}][]`, value)
                              }
                            />
                          )}

                          {/* Radio Button Pills */}
                          {data.component === 'RadioButtonPills' &&
                            data.data && (
                              <RadioGroup
                                name={data.slug}
                                options={data.data}
                                type="pills"
                                value={
                                  filters[`filters[${data.slug}][]`] as string
                                }
                                onChange={(value) =>
                                  setFilters(`filters[${data.slug}][]`, value)
                                }
                              />
                            )}

                          {data.property_type === 'string' && (
                            <ControlledInput
                              type="text"
                              className={styles.textInput}
                              placeholder={data.title}
                              //@ts-expect-error
                              value={filters[`filters[${data.slug}]`] || ''}
                              onChange={(value) =>
                                setFilters(`filters[${data.slug}]`, value)
                              }
                            />
                          )}

                          {data.property_type === 'boolean' &&
                            data.component !== 'RadioButton' &&
                            data.component !== 'RadioButtonPills' && (
                              <ToggleSwitcher
                                name={`filters[${data.slug}]`}
                                //@ts-expect-error
                                value={filters[`filters[${data.slug}]`] || '0'}
                                onChange={(value) =>
                                  //@ts-expect-error
                                  setFilters(`filters[${data.slug}]`, value)
                                }
                              />
                            )}

                          {data.property_type !== 'list' &&
                            data.property_type !== 'string' &&
                            data.property_type !== 'boolean' && (
                              <span className={styles.formItemGroup}>
                                <InputRange
                                  filterName={data.title}
                                  onChangeFrom={setFilters}
                                  onChangeTo={setFilters}
                                  fromPlaceholder="От"
                                  toPlaceholder="До"
                                  fromKey={`filters[${data.slug}][from]`}
                                  toKey={`filters[${data.slug}][to]`}
                                />
                              </span>
                            )}
                        </div>
                      )}
                    </div>
                  ),
              )}
            </React.Fragment>
          ))}
        </div>

        <div className={styles.formFooter}>
          <Button text="Показать на карте" onClick={() => applyFilters(true)} />
          <Button text="Показать" onClick={() => applyFilters()} />
        </div>
      </div>
    </Modal>
  );
};

export default OtherMainFilterModal;
